module.exports = __webpack_public_path__ + "static/kuhne-web-4ae0f33f36dbf5b3f0666a228a2f28ad.jpg";